import React from "react";
import { LuRefreshCw } from "react-icons/lu";
import { Button, Field, Textarea } from "../../../components/ui";
import { plural, t } from "../../../i18n";
import { ptBR } from "../../../i18n/pt-BR";
import { ItemTipo, OpmeBundle, ProcedimentoBundle } from "../../../types/resources.types";
import { TEXT_GROUNDS } from "../appeal";
import { AppealWizard } from "../useAppealWizard";

/** Passo 5: textos gerados pela IA, editáveis, e as referências encontradas por seção. */
export const GeneratedAppealStep: React.FC<{ w: AppealWizard }> = ({ w }) => {
  const order = w.order!;

  const refsSection = (title: string, bundles: (ProcedimentoBundle | OpmeBundle)[], kind: ItemTipo) => (
    <section className="flex flex-col gap-2 rounded-control border border-line p-3.5">
      <div className="flex items-center justify-between gap-2">
        <h4 className="text-body font-semibold">{title}</h4>
        <Button
          variant="outline"
          size="sm"
          loading={w.reloading === kind}
          disabled={!!w.reloading}
          icon={<LuRefreshCw size={16} aria-hidden />}
          onClick={() => w.reloadReferences(kind)}
        >
          {t(w.reloading === kind ? "appeals.generated.reloading" : "appeals.generated.reload")}
        </Button>
      </div>
      {bundles.length === 0 ? (
        <p className="text-caption text-fg-muted">{t("appeals.generated.noRefs")}</p>
      ) : (
        <ul className="flex flex-col divide-y divide-line">
          {bundles.map((b) => (
            <li key={b.nome} className="flex justify-between gap-3 py-2 text-caption">
              <span className="min-w-0 break-words">{b.nome}</span>
              <span className="shrink-0 font-semibold text-primary">{plural(b.referencias.length, ptBR.appeals.generated.refCount)}</span>
            </li>
          ))}
        </ul>
      )}
    </section>
  );

  return (
    <>
      <p className="text-body text-fg-muted">{t("appeals.generated.intro")}</p>
      <div className="flex flex-col gap-1">
        <h3 className="text-heading font-semibold uppercase">{t("appeals.generated.heading")}</h3>
        <p className="text-caption text-fg-muted">
          #{order.codigo} · {order.paciente} · {order.procedimento} · {order.data}
        </p>
      </div>

      <Field label={t("appeals.generated.denial")}>
        <Textarea rows={6} value={w.texts.identificacaoNegativa} onChange={(e) => w.updateText({ identificacaoNegativa: e.target.value })} />
      </Field>

      {w.activeGrounds.includes("bibliografia") && (
        <section className="flex flex-col gap-2.5">
          <div>
            <h3 className="text-label font-semibold text-fg-secondary">{t("appeals.generated.references")}</h3>
            <p className="text-caption text-fg-muted">{t("appeals.generated.referencesHint")}</p>
          </div>
          {refsSection(t("appeals.generated.procedures"), w.procedimentos, "CODIGO")}
          {refsSection(t("appeals.generated.opme"), w.opmes, "MATERIAL")}
        </section>
      )}

      {TEXT_GROUNDS.filter((g) => w.activeGrounds.includes(g)).map((g) => (
        <Field key={g} label={t(`appeals.generated.${g}`)}>
          <Textarea rows={6} value={w.texts[g]} onChange={(e) => w.updateText({ [g]: e.target.value })} />
        </Field>
      ))}
    </>
  );
};
